import React, { useEffect, useState } from "react";
import Logo from "components/Logo/Logo";
import MenuBar from "components/MenuBar/MenuBar";
import Navigation from "components/Navigation/Navigation";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/userSlice";
import { useNavigate } from "react-router-dom";
import { User } from "lucide-react";
import { Buffer } from "buffer";

const MainNav2Logged = () => {
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [menuOpen, setMenuOpen] = useState(false);

  const user = useSelector((state: any) => state.user.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    dispatch(logout());
    localStorage.removeItem("token");
    setMenuOpen(false);
    navigate("/login");
  };

  const renderAvatar = () => {
    if (user?.img?.data) {
      const avatarPreview = `data:${user.img.contentType};base64,${Buffer.from(
        user.img.data
      ).toString("base64")}`;
      return (
        <img
          src={avatarPreview}
          alt="Avatar"
          onClick={() => setMenuOpen(!menuOpen)}
          style={{
            width: "40px",
            height: "40px",
            objectFit: "cover",
            borderRadius: "50%",
            cursor: "pointer",
          }}
        />
      );
    }
    return (
      <User
        size={32}
        onClick={() => setMenuOpen(!menuOpen)}
        className="cursor-pointer text-gray-700 dark:text-white"
      />
    );
  };

  const renderUserMenu = () => (
    <div className="absolute right-4 top-16 bg-white border rounded shadow-md w-56 z-50 text-sm">
      {user ? (
        <>
          <button
            onClick={() => {
              navigate("/admin/profil");
              setMenuOpen(false);
            }}
            className="block w-full text-left px-4 py-2 hover:bg-gray-100"
          >
            Profil
          </button>

          {user.role === "admin" && (
            <button
              onClick={() => {
                navigate("/admin/gestionUsagers");
                setMenuOpen(false);
              }}
              className="block w-full text-left px-4 py-2 hover:bg-gray-100"
            >
              Gestion usagers
            </button>
          )}

          {(user.role === "admin" || user.role === "editor") && (
            <>
              <button
                onClick={() => {
                  navigate("/admin/ajouterArticle");
                  setMenuOpen(false);
                }}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100"
              >
                Ajouter article
              </button>
              <button
                onClick={() => {
                  navigate("/admin/modifierArticle");
                  setMenuOpen(false);
                }}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100"
              >
                Modifier article
              </button>
              <button
                onClick={() => {
                  navigate("/admin/ajouterInfolettre");
                  setMenuOpen(false);
                }}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100"
              >
                Ajouter infolettre
              </button>
              <button
                onClick={() => {
                  navigate("/admin/ajouterVideo");
                  setMenuOpen(false);
                }}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100"
              >
                Ajouter vidéo
              </button>
              <button
                onClick={() => {
                  navigate("/ajouterEvenement");
                  setMenuOpen(false);
                }}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100"
              >
                Ajouter événement
              </button>
              <button
                onClick={() => {
                  navigate("/supprimerEvenement");
                  setMenuOpen(false);
                }}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100"
              >
                Supprimer événement
              </button>
              <button
                onClick={() => {
                  navigate("/admin");
                  setMenuOpen(false);
                }}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100"
              >
                Panneau admin
              </button>
            </>
          )}

          <button
            onClick={handleLogout}
            className="block w-full text-left px-4 py-2 hover:bg-gray-100"
          >
            Déconnexion
          </button>
        </>
      ) : (
        <>
          <button
            onClick={() => {
              navigate("/login");
              setMenuOpen(false);
            }}
            className="block w-full text-left px-4 py-2 hover:bg-gray-100"
          >
            Connexion
          </button>
          <button
            onClick={() => {
              navigate("/register");
              setMenuOpen(false);
            }}
            className="block w-full text-left px-4 py-2 hover:bg-gray-100"
          >
            Enregistrement
          </button>
        </>
      )}
    </div>
  );

  const renderContent = () => {
    if (dimensions.width < 580) {
      return (
        <div className="h-20 flex justify-between items-center">
          <MenuBar />
          <Logo />
          <div className="relative">{renderAvatar()}</div>
        </div>
      );
    }

    return (
      <div className="h-20 flex justify-between items-center">
        <Logo />
        <div className="flex-[2] flex justify-center mx-4">
          <Navigation />
        </div>
        <div className="relative">{renderAvatar()}</div>
      </div>
    );
  };

  return (
    <div className="nc-MainNav2Logged relative z-10 bg-white dark:bg-neutral-900 border-b border-slate-100 dark:border-slate-700">
      <div className="container">{renderContent()}</div>
      {menuOpen && renderUserMenu()}
    </div>
  );
};

export default MainNav2Logged;
